<template>
  <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
    <template slot="header">
      <div class="col-8">
        <h4 class="card-title">Gecikmiş Kumbaralar</h4>
        <p class="card-category">Boşaltma zamanı geçmiş kumbaralar</p>
      </div>
      <div style="text-align: right;" class="col-4 card-title">
        <a-button icon="download" @click="exportCsv" :disabled="!rows.length">
          Excel'e Aktar
        </a-button>
      </div>
    </template>
    <a-table rowKey="moneybox_id" :columns="columns" :data-source="rows" :pagination="{ pageSize: 10 }">
      <span slot="last_unload" slot-scope="text, record">
        {{ record.never_unloaded ? 'Hiç boşaltılmadı' : formatDate(record.last_unload_date) }}
      </span>
      <span slot="days_overdue" slot-scope="text, record">
        <a-tag color="red" v-if="record.never_unloaded">Hiç boşaltılmadı</a-tag>
        <a-tag color="red" v-else>{{ record.days_overdue }} gün</a-tag>
      </span>
    </a-table>
  </card>
</template>

<script>
import { mapState } from 'vuex'
import Card from 'src/components/Cards/Card.vue'

export default {
  components: { Card },
  computed: {
    ...mapState({
      rows: (state) => state.Reports.overdue_moneyboxes,
    }),
  },
  mounted() {
    this.$store.dispatch('Reports/requestOverdueMoneyboxes')
  },
  methods: {
    formatDate(value) {
      if (!value) return '-'
      return new Date(value).toLocaleDateString('tr-TR')
    },
    exportCsv() {
      this.$exportToCsv(
        'gecikmis_kumbaralar',
        [
          { title: 'Kumbara', key: 'moneybox_name' },
          { title: 'Kod', key: 'moneybox_code' },
          { title: 'İşletme', key: 'corporation_name' },
          { title: 'Segment', key: 'segment_name' },
          { title: 'Son Boşaltma', key: 'last_unload_date' },
          { title: 'Gecikme (gün)', key: 'days_overdue' },
        ],
        this.rows.map((r) => ({
          ...r,
          last_unload_date: r.never_unloaded ? 'Hiç boşaltılmadı' : this.formatDate(r.last_unload_date),
        }))
      )
    },
  },
  data() {
    return {
      columns: [
        { title: 'Kumbara', dataIndex: 'moneybox_name', key: 'moneybox_name' },
        { title: 'İşletme', dataIndex: 'corporation_name', key: 'corporation_name' },
        { title: 'Segment', dataIndex: 'segment_name', key: 'segment_name' },
        { title: 'Son Boşaltma', key: 'last_unload', scopedSlots: { customRender: 'last_unload' } },
        { title: 'Gecikme', key: 'days_overdue', scopedSlots: { customRender: 'days_overdue' } },
      ],
    }
  },
}
</script>
